function fixedElementScroll() {
  var doc = document.documentElement;

  var header = document.querySelector('.x-main-header');
  var scrollTop = header.offsetHeight;

  var stickyElement = document.querySelector('.x-sticky-element');
  var stickyEnd = document.querySelector('.x-sticky-end');
  var profileSidebar = document.querySelector('.x-profile-sidebar');

  if (document.contains(stickyElement)) {
    profileSidebar.style.minHeight = stickyElement.offsetHeight + 'px';

    window.addEventListener('resize', function(){
      profileSidebar.style.minHeight = stickyElement.offsetHeight + 'px';
    });

    var scrollFunction = function() {
      var scrollPosition = doc.scrollTop;
      var stickyEndBottom = stickyEnd.getBoundingClientRect().bottom;

      if (scrollTop >= scrollPosition) {
        stickyElement.classList.remove('is-fixed');
        stickyElement.classList.remove('is-absolute');
      } else if (stickyEndBottom < window.innerHeight){
        stickyElement.classList.remove('is-fixed');
        stickyElement.classList.add('is-absolute');
      } else {
        stickyElement.classList.add('is-fixed');
        stickyElement.classList.remove('is-absolute');
      }
    };

    window.addEventListener('scroll', scrollFunction);
  }
}

fixedElementScroll();
